import { Button, Grid, Typography } from "@mui/material";
import { styled as styling } from "@mui/material/styles";

export const GridStyledTagline = styling(Grid)((props) => ({
  display: "flex",
  height: "520px",
  padding: "80px 120px",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: "48px",
  alignSelf: "stretch",
  background:
    "linear-gradient(86deg, rgba(255, 255, 255, 0.20) -18.74%, rgba(81, 42, 204, 0.20) 34.24%, rgba(168, 148, 229, 0.20) 89.32%, rgba(255, 255, 255, 0.20) 112.7%), #FFF",

  [props.theme.breakpoints.down("lg")]: {
    padding: "56px 32px",
    gap: "40px",
    height: "100%",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "56px 24px",
    gap: "24px",
    alignItems: "center",
  },
}));

export const GridTagline = styling(Grid)((props) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  gap: "24px",
  width: "100%",

  [props.theme.breakpoints.down("tablet")]: {
    alignItems: "center",
  },
}));

export const TaglineTitle = styling(Typography)((props) => ({
  fontFamily: "Georgia",
  color: "#261754",
  fontSize: "40px",
  fontWeight: "400",
  lineHeight: "48px",
  letterSpacing: "0.06px",
  textTransform: "unset",
  textAlign: "center",

  [props.theme.breakpoints.down("lg")]: {
    maxWidth: "700px",
    fontSize: "36px",
    lineHeight: "43.2px",
    letterSpacing: "0.36px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    maxWidth: "unset",
    fontSize: "24px",
    fontWeight: "400",
    lineHeight: "28.8px",
    letterSpacing: "0.036px",
    textAlign: "center",
  },
}));

export const TaglineSubtitle = styling(Typography)((props) => ({
  color: "#261754",
  fontFamily: "Inter",
  fontSize: "24px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "36px",
  letterSpacing: "0.036px",
  textAlign: "center",
  maxWidth: "1005px",

  [props.theme.breakpoints.down("lg")]: {
    maxWidth: "700px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    maxWidth: "unset",
    fontSize: "16px",
    lineHeight: "22.4px",
    textAlign: "center",
  },
}));

export const ButtonStyled = styling(Button)((props) => ({
  display: "flex",
  minWidth: "240px",
  width: "fit-content",
  padding: "12px 24px",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  textTransform: "capitalize",
  border: "1px solid #F1CC44",
  background: "linear-gradient(180deg, #FFE36A 50%, #FFC400 122.92%)",
  boxShadow: "0 2px 4px 0 rgba(104, 77, 0, 0.40)",
  color: "rgba(0, 0, 0, 0.87)",
  textAlign: "center",
  borderRadius: "10px",
  height: "54px",
  fontSize: "20px",
  fontWeight: "700",
  lineHeight: "30px",
  letterSpacing: "0.1px",

  ":hover": {
    background: "linear-gradient(180deg, #FFE36A 50%, #FFC400 122.92%)",
    fontWeight: 700,
  },

  [props.theme.breakpoints.down("lg")]: {
    minWidth: "220px",
    height: "48px",
    padding: "12px 24px",
    fontSize: "16px",
    lineHeight: "24px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    width: "100%",
  },
}));
